import { css } from '@linaria/core';

import { ROUTE_PATHS } from '@modules/route-paths';
import { INTELLECTUAL_PROPERTY_NOTICES } from '@modules/unauth/pages/legal/legal-details';

export const currentYear = new Date().getFullYear();

export const styles = {
  footer: css`
    width: 100%;
    margin-top: auto;
    padding: 24px clamp(16px, 3vw, 32px);
    border-top: 1px solid var(--ant-color-border-secondary);
    color: var(--brand-cream);
    background: var(--brand-deep-black);

    & .ant-typography {
      color: color-mix(in srgb, var(--brand-cream) 76%, transparent);
    }
  `,
  content: css`
    display: grid;
    grid-template-columns: minmax(260px, 1fr) repeat(2, minmax(180px, 240px));
    gap: clamp(24px, 4vw, 64px);
    width: 100%;
    max-width: 1600px;
    margin-inline: auto;
    padding-inline: clamp(16px, 3vw, 24px);

    @media (max-width: 760px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  `,
  brand: css`
    @media (max-width: 760px) {
      grid-column: 1 / -1;
    }
  `,
  links: css`
    min-width: 0;
  `,
  link: css`
    width: fit-content;
    color: color-mix(in srgb, var(--brand-cream) 76%, transparent);

    &:hover,
    &:focus-visible {
      color: var(--brand-gold-light);
    }
  `,
  bottom: css`
    grid-column: 1 / -1;
    padding-top: var(--ant-padding);
    border-top: 1px solid
      color-mix(in srgb, var(--brand-cream) 16%, transparent);
  `,
  legalNotice: css`
    grid-column: 1 / -1;
    max-width: 1120px;
    font-size: var(--ant-font-size-sm);
  `,
  legalLink: css`
    width: fit-content;
    color: var(--brand-gold-light);

    &:hover,
    &:focus-visible {
      color: var(--brand-cream);
    }
  `,
};

export const helpLinks = [
  { label: 'Central de Ajuda', path: ROUTE_PATHS.HELP },
  { label: 'Como comprar', path: ROUTE_PATHS.HOW_TO_BUY },
  { label: 'Como vender', path: ROUTE_PATHS.HOW_TO_SELL },
  { label: 'Compra Protegida', path: ROUTE_PATHS.PROTECTED_PURCHASE },
] as const;

export const supportLinks = [
  { label: 'Taxas', path: ROUTE_PATHS.FEES },
  {
    label: 'Trocas e cancelamentos',
    path: ROUTE_PATHS.RETURNS_AND_CANCELLATIONS,
  },
  { label: 'Contato', path: ROUTE_PATHS.CONTACT },
  { label: 'Termos de Uso', path: ROUTE_PATHS.TERMS_OF_USE },
  { label: 'Política de Privacidade', path: ROUTE_PATHS.PRIVACY_POLICY },
] as const;

export { INTELLECTUAL_PROPERTY_NOTICES };
